var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"white-background"}}),_c('div',{attrs:{"id":"dlgbox"}},[_c('div',{attrs:{"id":"dlg-header"}},[_vm._v("You are logged out.")]),_c('div',{attrs:{"id":"dlg-body"}},[_vm._v("Please log in to continue.")]),_c('div',{attrs:{"id":"dlg-footer"}},[_c('button',{staticClass:"dlgBtnOk",on:{"click":_vm.hideMessage}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }